import React from 'react';
import type { CalendarConnectionPrompt } from '../../types/messages';
import MessageActionCard from './MessageActionCard';

type Props = {
  prompt: CalendarConnectionPrompt;
};

const CalendarConnectionPromptMessage = ({ prompt }: Props) => (
  <MessageActionCard
    title={prompt.title}
    description={prompt.description}
    actionHref={prompt.actionPath}
    actionLabel={prompt.actionLabel}
  />
);

export default CalendarConnectionPromptMessage;
